import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import IntroPage from "../pages/IntroPage";
import RegistrationPage from "../pages/RegistrationPage";
import LoginPage from "../pages/LoginPage";
import HomePage from "../pages/HomePage";
import LevelPage from "../pages/LevelPage";
import AccountPage from "../pages/AccountPage";
import SilverChitPage from "../pages/SilverChitPage";
import GoldenchitPage from "../pages/GoldenchitPage" ;

import { LevelMap } from "../pages/LevelMap";
import UserhistoryPage from "../pages/UserhistoryPage";
import DiamondChit from "../pages/DiamondChit";
import GameFinishPage from "../pages/GameFinishPage";
import PrivacySupplement from "../pages/PrivacySupplement";


const router = createBrowserRouter([
  {
    path: "/",
    element: <IntroPage />,
  },
  {
    path: "/register",
    element: <RegistrationPage />,
  },
  {
    path: "/privacy-supplement",
    element: <PrivacySupplement />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/home",
    element: <HomePage />,
  },
  {
    path: "/levelpage/:level_no",
    element: <LevelPage />,
  },{
    path:"/account",
    element:<AccountPage />,
  },{
    path:"/silverchit",
    element:<SilverChitPage />,
  },{
    path:"/levelmap",
    element:<LevelMap />
  },{
    path:"/goldenchit",
    element:<GoldenchitPage />
  },{
    path:"/user-history",
    element:<UserhistoryPage />
  },{
    path:"/diamond-chit",
    element:<DiamondChit/>
  },{
    path:"/game-over",
    element:<GameFinishPage />
  }
]);

const Routing = () => {
  return <RouterProvider router={router} />;
};

export default Routing;
